import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;
  max-height: 120px;
  gap: 16px;
  color: white;
  font-size: 16px;
  font-weight: 500;
`; 

export const ElementContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  justify-content: center;
  height: 100%;
`;

export const NBACard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 120px;
  padding: 16px 24px;
  background: ${(props) => props.theme.colors?.background || "#ffffff"};
  border: 1px solid ${(props) => props.theme.colors?.border || "#e5e7eb"};
  border-radius: 8px;
  box-sizing: border-box;
`;

export const NBATitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`;

export const NBAIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #A78BFA;
`;

export const NBATitle = styled.span`
  font-size: 20px;
  font-weight: 600;
  color: ${(props) => props.theme.colors?.text || "#1f2937"};
`;

export const NBAFeedback = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.colors?.textSecondary || "#6b7280"};
`;